import React, { FC, PropsWithChildren } from 'react';
import { Tag, Tooltip, Typography } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import theme from '~/constants/theme';
import colors from '~/constants/colors';
import { CurrentUserIcon } from '~/img';
import direction from '~/utils/direction';
import { useDirection } from '~/hooks/i18nHooks';

interface Props extends PropsWithChildren {
  showLabel?: boolean;
}

export const WithCurrentUserTag: FC<Props> = (props) => {
  const { children, showLabel } = props;
  const [t] = useTranslation();
  const dir = useDirection();
  return (
    <Container dir={dir}>
      <Typography.Title>{children}</Typography.Title>
      {showLabel ? <Tag>{t('CURRENT USER')}</Tag> : null}
    </Container>
  );
};

export const WithCurrentUserIcon: FC<Props> = (props) => {
  const { children, showLabel } = props;
  const dir = useDirection();
  const [t] = useTranslation();
  return (
    <>
      {children}
      {showLabel ? (
        <IconContainer dir={dir}>
          <Tooltip color={colors.blue[50]} title={t('Current user')}>
            <CurrentUserIcon />
          </Tooltip>
        </IconContainer>
      ) : null}
    </>
  );
};

const IconContainer = styled.div`
  display: inline;
  span {
    font-size: 20px;
    ${direction.margin.left(5)};
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .ant-typography {
    ${direction.margin.right(24)};
    margin-top: 0;
    margin-bottom: 0;
  }

  .ant-tag {
    border-radius: 5px;
    border-width: 0;
    background-color: ${colors.normalTagBackground};
    color: ${colors.normalTagText};
  }

  @media (max-width: ${theme.breakpoints.sm}px) {
    flex-direction: column;
    align-items: flex-start;
    .ant-tag {
      margin: 12px 0;
    }
  }
`;
